/* tslint:disable */
/* eslint-disable */
/**
 * RCS.Carbon.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PVecType = {
    Base: 'Base',
    Code: 'Code',
    Arith: 'Arith',
    Net: 'Net',
    Function: 'Function',
    Stat: 'Stat',
    Spacer: 'Spacer',
    Empty: 'Empty'
} as const;
export type PVecType = typeof PVecType[keyof typeof PVecType];


export function instanceOfPVecType(value: any): boolean {
    for (const key in PVecType) {
        if (Object.prototype.hasOwnProperty.call(PVecType, key)) {
            if (PVecType[key as keyof typeof PVecType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PVecTypeFromJSON(json: any): PVecType {
    return PVecTypeFromJSONTyped(json, false);
}

export function PVecTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PVecType {
    return json as PVecType;
}

export function PVecTypeToJSON(value?: PVecType | null): any {
    return value as any;
}

export function PVecTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PVecType {
    return value as PVecType;
}

